// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Assets from "../../assets/Assets.bs.jsx";
import * as Dialog from "../../components/Dialog/Dialog.bs.jsx";
import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as MeterKeg from "../../components/MeterKeg/MeterKeg.bs.jsx";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as BackendUtils from "../../utils/BackendUtils.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as TableConsumptions from "../../components/TableConsumptions/TableConsumptions.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import DrinkDialogModuleCss from "./DrinkDialog.module.css";

let classes = DrinkDialogModuleCss;

function get(state, field) {
  if (field === "Tap") {
    return state.tap;
  } else {
    return state.consumption;
  }
}

function set(state, field, value) {
  if (field === "Tap") {
    return {
      tap: value,
      consumption: state.consumption
    };
  } else {
    return {
      tap: state.tap,
      consumption: value
    };
  }
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function DrinkDialog(props) {
  let unfinishedConsumptions = props.unfinishedConsumptions;
  let tapsWithKegs = props.tapsWithKegs;
  let onSubmit = props.onSubmit;
  let onDismiss = props.onDismiss;
  let preferredTap = props.preferredTap;
  let personName = props.personName;
  let tapsOptions = React.useMemo(() => {
    let tapsEntries = Object.entries(tapsWithKegs);
    return tapsEntries.map(param => {
      let keg = param[1];
      let tapName = param[0];
      return {
        text: <>
          {tapName + `: ` + keg.beer + ` ` + keg.serialFormatted}
          <MeterKeg.make
            keg={keg}
          />
        </>,
        value: tapName
      };
    });
  }, [tapsWithKegs]);
  let unfinishedConsumptionsDesc = React.useMemo(() => unfinishedConsumptions.toReversed(), [unfinishedConsumptions]);
  let preferredTapHasKeg = tapsOptions.some(param => param.value === preferredTap);
  let form = Form.use({
    tap: preferredTapHasKeg ? preferredTap : Stdlib_Option.getOr(Stdlib_Option.map(tapsOptions[0], param => param.value), ""),
    consumption: -1
  }, Validators$1.schema([Validators$1.required("Tap")]), param => {
    onSubmit(param.state.values);
  }, undefined, undefined, "OnDemand", undefined);
  return <Dialog.make
    className={classes.root}
    onClickOutside={onDismiss}
    visible={true}
  >
    <header>
      <h3>
        {personName}
      </h3>
      <button
        className={Styles.button.base}
        type={"button"}
        onClick={param => onDismiss()}
      >
        {"Zavřít"}
      </button>
    </header>
    {tapsOptions.length === 0 ? <p>
        {"Naražte sudy!"}
      </p> : <Form.Provider.make
        value={form}
      >
        <form
          onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
        >
          <Form.Field.make
            field={"Tap"}
            render={field => {
              let handleChange = ReForm__Helpers.handleChange(field.handleChange);
              return <fieldset
                className={classes.taps}
              >
                {tapsOptions.map(param => {
                  let value = param.value;
                  return <label
                    key={value} >
                    <input
                      className={Styles.radio.base}
                      checked={field.value === value}
                      name={"tap"}
                      type={"radio"}
                      value={value}
                      onChange={handleChange}
                    />
                    <span>
                      {param.text}
                    </span>
                  </label>;
                })}
              </fieldset>;
            }}
          />
          <Form.Field.make
            field={"Consumption"}
            render={field => {
              let handleChange = event => {
                let value = Stdlib_Option.getOrThrow(Stdlib_Int.fromString(event.target.value, undefined), undefined);
                field.handleChange(value);
                form.submit();
              };
              return <fieldset
                className={classes.consumptions}
              >
                <label>
                  <img
                    alt={""}
                    src={Assets.beerGlassSmall}
                  />
                  <input
                    checked={field.value === BackendUtils.smallBeerInMilliliters}
                    name={"consumption"}
                    type={"radio"}
                    value={BackendUtils.smallBeerInMilliliters.toString()}
                    onChange={handleChange}
                  />
                  <span>
                    {"Malé"}
                  </span>
                </label>
                <label>
                  <img
                    alt={""}
                    src={Assets.beerGlassLarge}
                  />
                  <input
                    checked={field.value === BackendUtils.largeBeerInMilliliters}
                    name={"consumption"}
                    type={"radio"}
                    value={BackendUtils.largeBeerInMilliliters.toString()}
                    onChange={handleChange}
                  />
                  <span>
                    {"Velké"}
                  </span>
                </label>
              </fieldset>;
            }}
          />
        </form>
      </Form.Provider.make>}
    <details
      className={classes.unfinishedConsumptions}
    >
      <summary
        id={"unfinished_consumptions"}
      >
        {"Nezaúčtovaná piva"}
      </summary>
      {unfinishedConsumptions.length === 0 ? <p>
          {personName + ` nemá nezaúčtovaná piva.`}
        </p> : <TableConsumptions.make
          ariaLabelledby={"unfinished_consumptions"}
          formatConsumption={props.formatConsumption}
          onDeleteConsumption={props.onDeleteConsumption}
          unfinishedConsumptions={unfinishedConsumptionsDesc}
        />}
    </details>
  </Dialog.make>;
}

let make = DrinkDialog;

export {
  classes,
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* classes Not a pure module */
